import { defineNuxtPlugin } from '#app'
import Vueset from '~/utils/Vueset.js'

export default defineNuxtPlugin((nuxtApp) => {
    // make it available as this.$set in Options API & templates
    nuxtApp.vueApp.config.globalProperties.$set = Vueset

    // and as `const { set } = useNuxtApp()` in <script setup>
    nuxtApp.provide('set', Vueset)
})